module.exports = "<div class=\"canvasWrapper\" #wrapper>\n    <canvas #canvas id=\"canvas\" style=\"width:100%\"></canvas>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/charts/simple-bar-chart/simple-bar-chart.component.html
// module id = ../../../../../src/app/components/charts/simple-bar-chart/simple-bar-chart.component.html
// module chunks = main